import { gql } from '@apollo/client';
import { PROMPT_FIELDS } from '../fragments/prompt';

gql`
  ${PROMPT_FIELDS}
  query Prompts($search: String, $typeId: Int, $limit: Int, $offset: Int) {
    admin {
      prompts(search: $search, typeId: $typeId, limit: $limit, offset: $offset) {
        ...PromptFields
      }
    }
  }
`;

gql`
  ${PROMPT_FIELDS}
  query Prompt($id: Int!) {
    admin {
      prompt(id: $id) {
        ...PromptFields
      }
    }
  }
`;
